// Gestionnaire de consentement par categorie, sans dependance externe.
// Le choix est conserve dans le stockage local du navigateur du visiteur.
// Il ne quitte jamais son appareil et n'est associe a aucun identifiant.

export const CLE = 'bstp-consentement';
export const VERSION = 2; // a incrementer si les categories changent
export const EVENEMENT = 'bstp-consentement-change';

export const CATEGORIES = [
  {
    id: 'necessaires',
    titre: 'Strictement nécessaires',
    texte:
      "Ils font fonctionner le site et mémorisent ce choix de consentement. Aucune donnée n'est transmise à un tiers.",
    verrouille: true,
  },
  {
    id: 'audience',
    titre: "Mesure d'audience",
    texte:
      "Pages vues, provenance des visiteurs, appareils utilisés. Ces statistiques nous servent à améliorer le site. Elles ne sont jamais utilisées pour vous suivre ailleurs sur le web.",
  },
  {
    id: 'tiers',
    titre: 'Contenus extérieurs',
    texte:
      "La carte OpenStreetMap qui situe notre dépôt. La refuser n'empêche rien : l'adresse reste affichée et vous pouvez toujours charger la carte d'un clic.",
  },
];

const PAR_DEFAUT = { necessaires: true, audience: false, tiers: false };

// Retourne { necessaires, audience, tiers } ou null si aucun choix n'a ete fait.
export function lireConsentement() {
  try {
    const brut = window.localStorage.getItem(CLE);
    if (!brut) return null;
    const v = JSON.parse(brut);
    if (!v || v.version !== VERSION) return null;
    // Recommandation CNIL : le choix est redemande au bout de six mois.
    const age = Date.now() - new Date(v.date).getTime();
    if (!v.date || Number.isNaN(age) || age > 182 * 24 * 60 * 60 * 1000) return null;
    return { ...PAR_DEFAUT, ...v.choix, necessaires: true };
  } catch (e) {
    // Navigation privee ou stockage bloque : aucun choix memorise.
    return null;
  }
}

export function estAccepte(categorie) {
  const c = lireConsentement();
  return Boolean(c && c[categorie]);
}

export function ecrireConsentement(choix) {
  const complet = { ...PAR_DEFAUT, ...choix, necessaires: true };
  try {
    window.localStorage.setItem(
      CLE,
      JSON.stringify({ version: VERSION, date: new Date().toISOString(), choix: complet })
    );
  } catch (e) {
    // On continue : le choix vaut au moins pour la session en cours.
  }
  window.dispatchEvent(new CustomEvent(EVENEMENT, { detail: complet }));
  return complet;
}

export function toutAccepter() {
  return ecrireConsentement({ audience: true, tiers: true });
}

export function toutRefuser() {
  return ecrireConsentement({ audience: false, tiers: false });
}

export function reinitialiserConsentement() {
  try {
    window.localStorage.removeItem(CLE);
  } catch (e) {
    // rien a faire
  }
  window.dispatchEvent(new CustomEvent(EVENEMENT, { detail: null }));
}
